import type { SessionResult } from '../types'
import { submitResult } from './api'

const KEY = 'laboratorio-historia-pending-results'

export function savePendingResult(result: SessionResult): void {
  const current = getPendingResults().filter((item) => item.sessionId !== result.sessionId)
  localStorage.setItem(KEY, JSON.stringify([...current, result]))
}

export function removePendingResult(sessionId: string): void {
  const remaining = getPendingResults().filter((item) => item.sessionId !== sessionId)
  localStorage.setItem(KEY, JSON.stringify(remaining))
}

export function getPendingResults(): SessionResult[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '[]') as SessionResult[]
  } catch {
    return []
  }
}

export async function retryPendingResults(): Promise<number> {
  const pending = getPendingResults()
  const remaining: SessionResult[] = []
  let sent = 0
  for (const result of pending) {
    try {
      await submitResult(result)
      sent += 1
    } catch {
      remaining.push(result)
    }
  }
  localStorage.setItem(KEY, JSON.stringify(remaining))
  return sent
}
